import { compositeOverBg, contrastRatio, deriveMutedFg, hoverWouldEraseText, isDarkSurface, isFullyTransparent, pickReadableForeground, relativeLuminance, surfacesMatch } from "./modules/color.js";
import { normalizeThemeColors } from "./modules/normalizeThemeColors.js";

//#region src/color.ts
const colorUtils = {
	compositeOverBg,
	contrastRatio,
	deriveMutedFg,
	hoverWouldEraseText,
	isDarkSurface,
	isFullyTransparent,
	pickReadableForeground,
	relativeLuminance,
	surfacesMatch
};

//#endregion
export { colorUtils, normalizeThemeColors };
//# sourceMappingURL=color.js.map